module.exports = __webpack_public_path__ + "media/images/access_h3_bg_ginza-eee48ad1505bd18d09346b7a48f4e1c5.png";